'use client';

export { default } from './DialogActions';
export { default as dialogActionsClasses } from './dialogActionsClasses';
export * from './dialogActionsClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/DialogActions/index.js
// module id = 918
// module chunks = 25